import { render, staticRenderFns } from "./PorjectEstimatesRoleTable.vue?vue&type=template&id=0377028c"
import script from "./PorjectEstimatesRoleTable.vue?vue&type=script&lang=js"
export * from "./PorjectEstimatesRoleTable.vue?vue&type=script&lang=js"
import style0 from "./PorjectEstimatesRoleTable.vue?vue&type=style&index=0&id=0377028c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports